import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconColor, trend }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-4">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center">
          <Icon name={icon} size={18} color={iconColor} />
        </div>
        <p className="text-xs text-muted-foreground">{title}</p>
      </div>
      <p className="text-xl font-bold text-foreground">{value}</p>
      {change && (
        <span className={`text-xs font-medium ${
          changeType === 'positive' ? 'text-emerald-500' : changeType === 'negative' ? 'text-red-400' : 'text-muted-foreground'
        }`}>
          {change} <span className="text-muted-foreground font-normal">{trend}</span>
        </span>
      )}
    </div>
  );
};

export default MetricCard;
